import { render } from "./LolPage.vue?vue&type=template&id=13013935&scoped=true"
import script from "./LolPage.vue?vue&type=script&lang=js"
export * from "./LolPage.vue?vue&type=script&lang=js"

import "./LolPage.vue?vue&type=style&index=0&id=13013935&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13013935"]])

export default __exports__